<div class="modal-header">
  <h4 class="modal-title"> {{'editArticleNumberMappingPopup.invalid_mappings.title' | translate}}</h4>
</div>

<div class="modal-body pt-0">
  <div class="modal-body-inner minh-200">
    <p class="middle">
      {{'editArticleNumberMappingPopup.invalid_mappings.description' | translate}}
    </p>
    <table class="table table-hover table-striped number-mapping-table fixed-layout" fixedHeader>
      <thead>
      <tr>
        <th>{{'editArticleNumberMappingPopup.label.article_number' | translate}}</th>
        <th>{{'editArticleNumberMappingPopup.label.custom_article_number' | translate}}</th>
      </tr>
      </thead>
    </table>
    <div class="overflow-xh" style="min-height: 180px">
      <table class="table table-hover table-striped number-mapping-table fixed-layout mb-0">
        <tbody minRowCount [update]="update">
        <tr *ngFor="let invalidMapping of invalidMappings; let i = index">
          <td>
            {{invalidMapping.articleNumber}}
          </td>
          <td>
            {{invalidMapping.customArticleNumber}}
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-primary btn-forward" (click)="close()">
    {{'global.label.ok' | translate}}
  </button>
</div>
